import {
    IonHeader,
    IonToolbar,
    IonButton,
    IonModal,
    IonTitle,
    IonContent,
    IonSegment,
    IonSegmentButton,
} from "@ionic/react";
import React, { useRef } from "react";

interface Props {
    isOpen: boolean;
    onReLogin: () => void;
    onContinue: () => void;
}

const SessionExpiryModal: React.FC<Props> = ({ isOpen, onReLogin, onContinue }) => {
    const modal = useRef<HTMLIonModalElement>(null);

    return (
        <IonModal
            backdropDismiss={false}
            showBackdrop={true}
            ref={modal}
            isOpen={isOpen}
            initialBreakpoint={0.5}
            breakpoints={[0.5, 0.75]}
        >
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Session Status</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent class="ion-padding">
                <p>Your session have expired.</p>

                <p>To make sure your changes sync with the server, please log in again when you have a connection.</p>

                <IonButton color="primary" onClick={(e) => onReLogin()} expand="block">
                    Log in again
                </IonButton>

                <p></p>
                <p>
                    You can also continue using the app. Your changes will be saved locally and will sync the next time
                    you log in.
                </p>

                <IonSegment>
                    <IonSegmentButton onClick={(e) => onContinue()}>Continue without logging in</IonSegmentButton>
                </IonSegment>
            </IonContent>
        </IonModal>
    );
};

export default SessionExpiryModal;
